exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-clear-filters {\n    display: inline-block;\n    margin: 0 .5em;\n    text-decoration: underline;\n}\n.btn-clear-filters:hover {\n    text-decoration: none;\n}\n", ""]);

// exports
